import React from "react";
import { Button } from "expano-components";
import { Modal } from "components";

const OtherRealStockDataModal = ({ data, handleClose }) => {
  return (
    <Modal
      size="md"
      header={{
        title: "Szczegółowe dane",
      }}
      footer={<Button type="cancel" text="Zamknij" onClick={handleClose} />}
      handleClose={handleClose}
    >
      <div className="popup__body p-0">
        <p>
          ERP Stan magazynowy (erp_comarch_optima_warehouse_stock):{" "}
          {data?.erp_comarch_optima_warehouse_stock}
        </p>
        <p>
          ERP ilość zarezerwowana (erp_quantity_reserved):{" "}
          {data?.erp_quantity_reserved}
        </p>
        <p>Erp stan (erp_stock): {data?.erp_stock}</p>
        <p>ESB stan realny (esb_real_stock): {data?.esb_real_stock}</p>
        <p>Stan importer (importer_stock): {data?.importer_stock}</p>
        <p>Stan realny (real_stock): {data?.real_stock}</p>
        <p>
          WMS Ilość niezebrana (wms_not_picked_product_quantity):{" "}
          {data?.wms_not_picked_product_quantity}
        </p>
        <div className="m-t-20" />
        <p>ERP Stan magazynowy = Erp stan - ERP ilość zarezerwowana</p>
        <p>ESB stan realny = ERP Stan magazynowy + WMS Ilość niezebrana</p>
        <p>Stan realny = Stan importer + ESB stan realny</p>
      </div>
    </Modal>
  );
};

export default OtherRealStockDataModal;
